import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b5484492"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-container" }
const _hoisted_2 = { class: "main-ctn" }

import { ref, computed, watch } from "vue"
import NavTabber from "@/components/NavTabber.vue"
// import MapMain from "@/layout/mapMain/index.vue"
import { useRoute } from "vue-router"

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

// import Header from "@/components/Header.vue"
const setName = ref([])
const route = useRoute()
const includes = ref(["Home", "Policy", "ResourcePlazaGc", "ResourcePlaza", "projectDemand"])
const key = computed(() => {
  return route.path
})
watch(
  () => route,
  (newVal, oldVal) => {
    // 需要刷新
    setName.value = []
    if (route.meta.catch && newVal.meta.keepAlive) {
      setName.value.push(newVal.name)
    }
  },
  {
    deep: true,
    immediate: true
  }
)

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          (_openBlock(), _createBlock(_KeepAlive, {
            include: includes.value,
            exclude: setName.value
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
          ], 1032, ["include", "exclude"]))
        ]),
        _: 1
      })
    ]),
    _withDirectives(_createVNode(NavTabber, null, null, 512), [
      [_vShow, _unref(route).meta.bottomNavShow]
    ])
  ]))
}
}

})